(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  function onTabClick(event) {
    let activeTabs = document.querySelectorAll('.tab-active');

    // deactivate existing active tab and panel
    activeTabs.forEach(function (tab) {
      tab.className = tab.className.replace('tab-active', '');
    });

    const tab_name = event.target.getAttribute('href').split('#')[1];
    console.log('switching to tab: ' + tab_name);

    // activate new tab and panel
    event.target.className += ' tab-active';
    document.getElementById(tab_name).className += ' tab-active';
  }

  const tabs = document.querySelectorAll('.product-tab');
  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', onTabClick, false);
  }

  } catch(e) { console.error(e); }
})();
})();
